<template>
  <filter-groupings-expand-toggle v-bind="$attrs" :cache-key="cacheKey" />
  <filter-grouping
    v-if="checkboxFilters"
    title="Authors"
    icon="person_search"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.teamMemberFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['team_member_ids'] })"
    container-classes="team"
  >
    <team-member-filter
      :checkbox-filter="checkboxFilters.team_member_ids"
      :tri-state="features.ARTICLE_FILTERS"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters"
    title="Article Options"
    icon="tune"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.otherFilterGroup"
    :has-filters="
      searchStore.hasFilters({
        exclude: ['team_member_ids', 'tags'],
      })
    "
    container-classes="options"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.is_exclusive"
      :tri-state="features.ARTICLE_FILTERS"
      @checkbox-change="triggerFiltering"
    />
    <checkbox-filter
      :checkbox-filter="checkboxFilters.category_ids"
      :tri-state="features.ARTICLE_FILTERS"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useSearchFilter } from '@/composables/search-filter'
import { useSearchStore } from '@/stores/search'
import CheckboxFilter from '@/components/search/checkbox-filter.vue'
import FilterGrouping from '@/components/search/filter-grouping.vue'
import TeamMemberFilter from '@/components/search/team-member-filter.vue'
import FilterGroupingsExpandToggle from '@/components/search/filter-groupings-expand-toggle.vue'

/** STATE **/
const searchStore = useSearchStore()

/** NON REACTIVE **/
// groupingIds and cacheKey use to persist expanded state to local storage
const groupingIds = {
  teamMemberFilterGroup: 'teamMemberFilterGroup',
  otherFilterGroup: 'otherFilterGroup',
}

// local storage cache key for which filters are expanded
const cacheKey = 'article-filter-groupings-expanded-v1'

/** EMITS **/
const emit = defineEmits(['filter-update'])

/** COMPOSABLES **/
const { features, checkboxFilters, triggerFiltering, initFilterGroupingsExpandedCache } =
  useSearchFilter({ emit })

/** LIFECYCLE **/
onBeforeMount(() => {
  // init expanded state from local storage
  initFilterGroupingsExpandedCache({ cacheKey, groupingIds })
})
</script>
